import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

export function useListExternalApis(
  params: {
    includeInactive?: boolean;
    search?: string;
    kind?: 'general' | 'erp_submission';
  } = {},
) {
  return useQuery(
    orpc.externalApis.list.queryOptions({
      input: {
        includeInactive: params.includeInactive,
        search: params.search,
        kind: params.kind,
      },
    }),
  );
}

export function useGetExternalApi(id: string | null | undefined) {
  return useQuery(
    orpc.externalApis.get.queryOptions({
      input: { id: id ?? '' },
      enabled: !!id,
    }),
  );
}

export function useCreateExternalApi() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.externalApis.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.externalApis.list.key(),
        });
      },
    }),
  );
}

export function useUpdateExternalApi() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.externalApis.update.mutationOptions({
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries({
          queryKey: orpc.externalApis.list.key(),
        });
        queryClient.invalidateQueries({
          queryKey: orpc.externalApis.get.key({ input: { id: variables.id } }),
        });
      },
    }),
  );
}

export function useDeleteExternalApi() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.externalApis.delete.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.externalApis.list.key(),
        });
      },
    }),
  );
}

export function useToggleExternalApiActive() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.externalApis.toggleActive.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: orpc.externalApis.list.key(),
        });
      },
    }),
  );
}

export function useTestExternalApiRequest() {
  return useMutation(orpc.externalApis.testRequest.mutationOptions());
}
